export function isObject<T extends object>(value: unknown): value is T {
  return value !== null && !Array.isArray(value) && typeof value === "object";
}
